import script from "./WksMediaModalCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./WksMediaModalCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./WksMediaModalCarousel.vue?vue&type=style&index=0&id=39420b7e&scoped=true&lang=css"
import "./WksMediaModalCarousel.vue?vue&type=style&index=1&id=39420b7e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39420b7e"]])

export default __exports__